module.exports = __webpack_public_path__ + "static/media/team-illustration-2.e4674d7c.png";